export default function toolbar({ variables }) {
    return {
        MuiToolbar: {
            defaultProps: {
                variant: "dense",
            },
            styleOverrides: {
                root: {
                    color: variables.text_primary,
                },
                dense: {
                    minHeight: variables.component_height_large,
                },
                gutters: {
                    paddingLeft: variables.spacing_05,
                    paddingRight: variables.spacing_05,
                    "@media (min-width:600px)": {
                        paddingLeft: variables.spacing_06,
                        paddingRight: variables.spacing_06,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=toolbar.js.map